<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <div class="条件区">
      <app-wmsm-WHQRtconditions [WHQKey]="onQueryClick1()" [show]="true" [ShowBuyer]="true"
      [ShowVendor]="true" [ShowTime]="true" [ShowPONO]="true"  [ShowNotInvoice]="false"  [Query]="false"
       [ShowApplyDept]="false" [ShowInvoiceNo]="false"  [ShowPANO]="false" [ShowBillingStatus]="false"
       [maintainNotInvoice]="true" [ShowSend]="false" [ShowSecondQuery]="false" [ShowSecondDown]="false"

        (listenForm)="getFormValue($event)" ></app-wmsm-WHQRtconditions>
    </div>
    <div class="信息区" style="float: right"></div>
    <nz-card>
    <div >
      <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
    </div>
    <div class="表格" >
      <nz-table #rowSelectionTable nzShowSizeChanger [nzData]="listOfData" style="margin-bottom: 10px" nzSize="middle"
        (nzPageIndexChange)="myChange($event)"
         [nzFrontPagination]="false" [nzShowPagination]='false'
        [nzPageSize]='pageSize' [nzPageIndex]='pageIndex' [nzScroll]="{ y: '600px',x:'1600px' }">
        <thead>
          <tr>
            <th scope="col" nzWidth="90px" style="text-align:center;">{{ "WhetherInvoice" | translate}}</th>
            <th scope="col" [nzSortFn]="true" (nzSortOrderChange)="sortChange($event)" nzWidth="120px"
              style="text-align:center;">{{ "PoNo" | translate}}</th>
            <th scope="col" [nzSortFn]="true" (nzSortOrderChange)="sortChange($event)" nzWidth="120px"
              style="text-align:center;">{{ "CompanyCode" | translate }}</th>
            <th scope="col"  nzWidth="110px"
              style="text-align:center;">{{ "PoType" | translate}}</th>
            <th scope="col"  nzWidth="110px"
              style="text-align:center;">{{ "PoAmount" | translate}}</th>
            <th scope="col" nzWidth="80px" style="text-align:center;">{{ "InvoiceAmount" | translate}}</th>
            <th scope="col" nzWidth="120px" style="text-align:center;">{{ "TotalInvoiceTax" | translate}}</th>
            <th scope="col" nzWidth="60px" style="text-align:center;">{{ "table.WHQCurrency" | translate}}</th>
            <th scope="col" nzWidth="90px" style="text-align:center;">{{ "VendorCode" | translate}}</th>
            <th scope="col" nzWidth="150px" style="text-align:center;">{{ "VendorName" | translate}}</th>
            <th scope="col" nzWidth="80px" style="text-align:center;">{{ "rtSatementSendDate" | translate}}</th>
            <th scope="col" nzWidth="80px" style="text-align:center;">{{ "SourcerEmplid" | translate}}</th>
            <th scope="col" nzWidth="100px" style="text-align:center;">{{ "Buyer" | translate}}</th>
            <th scope="col" nzWidth="60px" style="text-align:center;"[nzRight]="fixedColumn" >{{ "particulars" | translate}} </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of rowSelectionTable.data;let i=index" >
            <td style="text-align:center;">{{data.haveInvoice}}</td>
            <td>

              <span class="linkLabel"  (click)="RnoOnClick(data)"
                style="text-decoration:underline;color:blue">
                {{data.pono}}
              </span>
            </td>
            <td>{{data.companyCode}}</td>
            <td>{{data.category}}</td>
            <td style="text-align: right; word-break:break-all;">{{data.poAmout | number: '1.2-2' }}</td>
            <td style="text-align: right; word-break:break-all;">{{data.invoiceAmount | number: '1.2-2' }}</td>
            <td style="text-align: right; word-break:break-all;">{{data.taxes | number: '1.2-2' }}</td>
            <td>{{data.currency}}</td>
            <td>{{data.vendorCode}}</td>
            <td>{{data.vendorName}}</td>
            <td>{{data.poApprovedate | date:'yyyy-MM-dd'}}</td>
            <td>{{data.buyer}}</td>
            <td>{{data.buyerName}}</td>
            <td [nzRight]="fixedColumn" style="text-align: center;" >
              <div nz-row >
              <div nz-col style="margin-left: 15px;">
                <div *ngIf="data.haveInvoice=='Y' ">
                  <span nz-icon nzType="file-search" nzTheme="outline" (click)="showmodal2(data)" nz-tooltip nzTooltipTitle="{{'particulars' | translate}}"
                  style="font-size: 20px; cursor: pointer;color: #0C8AFF;"></span>
                </div>
              </div>
              <div nz-col style="margin-left: 15px;">
              <div *ngIf="data.isHyperlink=='Y' ">
                <span nz-icon nzType="profile" nzTheme="twotone" (click)="showHyperlink(data)" nz-tooltip nzTooltipTitle="{{'ElectronicInvoice' | translate}}"
                  style="font-size: 20px; cursor: pointer;"></span>
              </div>
            </div>
          </div>


            </td>

          </tr>
        </tbody>
      </nz-table>
      <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
        nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50,100]" [nzPageSize]='pageSize'
        (nzPageSizeChange)="nzPageSizeChange($event)"
        (nzPageIndexChange)="nzPageIndexChange($event)"></nz-pagination>
        <ng-template #renderItemTemplate let-type let-page="page">

          <a *ngIf="type === 'page'">{{ page }}</a>
          <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
          <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
        </ng-template>
    </div>
  </nz-card>
    <nz-modal [(nzVisible)]="isVisible" nzTitle='{{"Remark"|translate}}' (nzOnCancel)="handleCancel()"
      (nzOnOk)="handleOk()">
      <ng-container *nzModalContent>
        <textarea rows="6" nz-input [(ngModel)]="inputValue"></textarea>
      </ng-container>
    </nz-modal>
  </div>
</nz-spin>


<nz-modal [(nzVisible)]="isVisible2" nzTitle='{{"particulars"|translate}}' (nzOnCancel)="handleCancel2()"
(nzOnOk)="handleOk2()" nzOkText=" " nzKeyboard="true" >
<ng-container *nzModalContent>
  <div *ngIf="noInvoiceData" style="text-align:center; margin: 30px 0;">
    <span style="color:#1890ff; text-decoration:underline; cursor:pointer;">{{'NoUnsubmittedPaymentData'|translate}}</span>
  </div>
  <div *ngIf="!noInvoiceData" class="Rules2">
  <nz-descriptions  nzBordered  *ngFor="let data of modaldata2;" style="margin-bottom: 10px;" >
    <nz-descriptions-item nzTitle='{{"InvoiceNo"|translate}}'>{{data.invoiceNo}}</nz-descriptions-item>
    <nz-descriptions-item nzTitle='{{"InvoiceDate"|translate}}'>{{data.invoiceDate | date:'yyyy-MM-dd'}}</nz-descriptions-item>
    <nz-descriptions-item nzTitle='{{"table.WHQCurrency"|translate}}'>{{data.currency}}</nz-descriptions-item>
    <nz-descriptions-item nzTitle='{{"InvoiceAmountBeforeTax"|translate}}' >{{data.amount | number: '1.2-2' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle='{{"Taxes"|translate}}' >{{data.tax | number: '1.2-2' }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle='{{"Remark"|translate}}'>{{data.remark}}</nz-descriptions-item>
    <nz-descriptions-item nzTitle='{{"ElectronicFileInvoice"|translate}}' >
      <span [ngClass]="{'disabled': data.invoiceElectronic == null || data.invoiceElectronic == ''}"
      nz-icon nzType="file" nzTheme="twotone"
      style="font-size: 20px;margin-right: 5px;cursor: pointer;"
      nz-tooltip nzTooltipTitle="{{data.invoiceElectronicName}}"
      (click)="DowmloadFile(data.invoiceElectronic,data.invoiceElectronicName)">
    </span>

<!--
      <span  nz-icon nzType="file" nzTheme="twotone"  style="font-size: 20px;margin-right: 5px;cursor: pointer;"
      nz-tooltip nzTooltipTitle="{{data.invoiceElectronicName}}"  (click)="DowmloadFile(data.invoiceElectronic)"></span> -->
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle='{{"OtherFiles1"|translate}}'>
      <span [ngClass]="{'disabled': data.otherAttachment == null || data.otherAttachment == ''}"
      nz-icon nzType="file" nzTheme="twotone"
      style="font-size: 20px;margin-right: 5px;cursor: pointer;"
      nz-tooltip nzTooltipTitle="{{data.otherAttachmentName}}"
      (click)="DowmloadOtherFiles(data.otherAttachment,data.otherAttachmentName)">
    </span>
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle='{{"BuyerOtherFiles1"|translate}}'>
      <span [ngClass]="{'disabled': data.purchaseAttachment == null || data.purchaseAttachment == ''}"
        nz-icon nzType="file" nzTheme="twotone"  style="font-size: 20px;margin-right: 5px;cursor: pointer;"
      nz-tooltip nzTooltipTitle="{{data.purchaseAttachmentName}}"   (click)="DowmloadBuyerOtherFiles(data.purchaseAttachment,data.purchaseAttachmentName)"></span>
    </nz-descriptions-item>
  </nz-descriptions>
</div>
</ng-container>
<div *nzModalFooter style="margin-left: 750px;">
  <button nz-button (click)="handleCancel2()"  nzType="primary" class="default-button;" style="color: aliceblue;">{{"Cancel" |translate }}</button>
</div>
</nz-modal>

<!-- Hyperlink -->
<nz-modal [(nzVisible)]="isHyperlink" (nzOnCancel)="handleCancel4()" (nzOnOk)="handleOk4()" nzOkText=" "  nzTitle='{{"ElectronicInvoice"|translate}}'
  nzKeyboard="true" >
  <ng-container *nzModalContent>
    <div class="HaplinkmodelRules">
    <nz-descriptions nzBordered *ngFor="let data of Haplinkmodel; let i=index" style="margin-bottom: 10px;">
      <nz-descriptions-item nzTitle='{{"InvoiceNo"|translate}}' >{{data.invoiceNo}}</nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"InvoiceDate"|translate}}'>{{data.invoiceDate | date:'yyyy-MM-dd'}}</nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"DateOfConfirmation"|translate}}'>{{data.createdOn | date:'yyyy-MM-dd'}}</nz-descriptions-item>

      <nz-descriptions-item nzTitle='{{"OperatorCode"|translate}}'>{{data.sellerVat}}</nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"OperatorName"|translate}}' [nzSpan]="2">{{data.sellerName}}</nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"BuyerCode"|translate}}'>{{data.buyerVat}}</nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"BuyerName"|translate}}' [nzSpan]="2"> {{data.buyerName}}</nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"VehicleNumber1"|translate}}'>{{data.carrierNumber1}}</nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"VehicleNumber2"|translate}}'>{{data.carrierNumber2}}</nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"GeneralRemarks"|translate}}'>{{data.remark}}</nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"TotalSales"|translate}}'>{{data.totalSalesAmount  | number: '1.2-2'}} </nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"RetailSales"|translate}}'>{{data.zeroTaxSalesAmount | number: '1.2-2' }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"Tax-freeSales"|translate}}'>{{data.freeTaxSalesAmount | number: '1.2-2' }}</nz-descriptions-item>

      <nz-descriptions-item nzTitle='{{"BusinessTax"|translate}}'>{{data.tax | number: '1.2-2' }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"Amount"|translate}}'>{{data.total | number: '1.2-2' }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"Tax"|translate}}'>{{data.taxType }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle='{{"Exchange"|translate}}'>{{data.exchangeRate}}</nz-descriptions-item>

    </nz-descriptions>

  </div>


  </ng-container>
  <div *nzModalFooter style="margin-left: 750px;">
    <button nz-button (click)="handleCancel4()" style="color: aliceblue;">{{"Cancel" |translate }}</button>
  </div>
</nz-modal>
